<template>
  <validation-observer ref="form" tag="div">
    <v-card color="grey lighten-1" class="pt-6" flat rounded="xl">
      <v-container class="px-6">
        <v-row>
          <v-col>
            <validation-provider v-slot="{ errors }" tag="div" mode="eager" name="Ad">
              <v-text-field
                v-model="data.invaddrname"
                label="Ad"
                filled
                rounded
                placeholder="Adınızı yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider v-slot="{ errors }" tag="div" mode="eager" name="Soyad">
              <v-text-field
                v-model="data.invaddrsurname"
                label="Soyad"
                filled
                rounded
                placeholder="Soyadınızı yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-provider v-slot="{ errors }" tag="div" mode="eager" name="Firma Adı">
              <v-text-field
                v-model="data.invaddrcompname"
                label="Firma Adı"
                filled
                rounded
                placeholder="Firma Adını yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="4">
            <validation-provider v-slot="{ errors }" tag="div" mode="eager" name="Vergi Dairesi">
              <v-text-field
                v-model="data.invaddrtaxtdept"
                label="Vergi Dairesi"
                filled
                rounded
                placeholder="Vergi dairesini yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col md="4">
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Vergi No / TC Kimlik No"
              rules="required|min:3"
            >
              <v-text-field
                v-model="data.invaddrvatno"
                label="Vergi No / TC Kimlik No"
                filled
                rounded
                placeholder="Vergi No veya TC Kimlik No yazın"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col md="4">
            <v-autocomplete
              v-model="data.invaddreinvtype"
              :items="callCenterStore.invaddreinvTypes"
              label="Fatura Tipi"
              eager
              filled
              rounded
              auto-select-first
              autocomplete="new-password"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Telefon"
              rules="length:14"
            >
              <v-text-field
                v-model="data.invaddrtel"
                filled
                rounded
                v-maska="'0### ### ## ##'"
                label="Telefon Numarası"
                placeholder="Lütfen telefon numaranızı girin"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="E-Posta"
              rules="email"
            >
              <v-text-field
                v-model="data.invaddremail"
                filled
                rounded
                label="E-Posta Adresi"
                placeholder="E-Posta adresinizi girin"
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="İl"
              rules="required"
            >
              <v-autocomplete
                v-model="data.invaddrcity"
                :items="CITY_STATE"
                item-text="il"
                return-object
                label="İl"
                eager
                filled
                rounded
                auto-select-first
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="İlçe"
              rules="required"
            >
              <v-autocomplete
                v-model="data.invaddrstate"
                label="İlçe"
                filled
                rounded
                :items="data.invaddrcity.ilceleri"
                auto-select-first
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              tag="div"
              mode="eager"
              name="Adres"
              rules="required|min:10"
            >
              <v-textarea
                v-model="data.invaddr"
                label="Adres"
                rows="3"
                filled
                rounded
                autocomplete="new-password"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-container class="px-6">
      <v-row align="center" class="my-9">
        <v-col md="6">
          <v-btn
            class="text-capitalize"
            plain
            x-large
            block
            rounded
            @click="callCenterStore.decrease()"
            >Geri Git
          </v-btn>
        </v-col>
        <v-col md="6">
          <v-btn
            color="secondary"
            class="text-capitalize"
            depressed
            rounded
            x-large
            block
            @click="continueStep()"
          >
            Devam Et
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </validation-observer>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";

// Utils
import { CITY_STATE } from "@utils";
import { useRouter } from "@core/utils";

// Store
import { useCallCenterStore } from "@/stores/callCenter";

// Icon
import { mdiCalendar, mdiClock } from "@mdi/js";

export default {
  setup() {
    // Store
    const callCenterStore = useCallCenterStore();

    const { route } = useRouter();

    const form = ref(null);

    const data = ref({
      invaddrname: "",
      invaddrsurname: "",
      invaddrcompname: "",
      invaddrvatno: "",
      invaddrtaxtdept: "",
      invaddreinvtype: "",
      invaddrtel: "",
      invaddremail: "",
      invaddrcity: "",
      invaddrstate: "",
      invaddr: "",
    });

    const continueStep = async () => {
      const isValid = await form.value.validate();

      if (!isValid) {
        return;
      }
      callCenterStore.data.invoice = data.value;
      callCenterStore.increment();
    };

    onMounted(async () => {
      if (route.value.params.item) {
        data.value = callCenterStore.data.invoice;
    
        if (data.value.invaddrcity) {
          data.value.invaddrcity = CITY_STATE.find((item) => item.il === data.value.invaddrcity);
        }
      }
    });
    return {
      callCenterStore,
      continueStep,
      form,
      data,
      CITY_STATE,

      icons: {
        mdiCalendar,
        mdiClock,
      },
    };
  },
};
</script>

<style></style>
